import SEOLandingPage from "@/components/SEOLandingPage";

const UGCAgenturWien = () => (
  <SEOLandingPage
    lang="de"
    title="UGC Agentur Wien | AI UGC Creator Wien | Fuel72"
    metaDescription="UGC Agentur Wien: Professionelle AI UGC Videos für Wiener Unternehmen. 72 Stunden Lieferung."
    keywords="ugc agentur wien, ugc creator wien, ugc wien, ugc österreich"
    canonical="https://www.fuel72.com/ugc-agentur-wien"
    hreflang={[{ lang: "de", href: "https://www.fuel72.com/ugc-agentur-wien" }]}
    heroTitle="UGC Agentur"
    heroHighlight="Wien"
    heroDescription="Professionelle AI UGC Videos für Wiener Unternehmen. 72 Stunden Lieferung."
    sections={[
      { title: "UGC Agentur Wien", content: "Wien ist das wirtschaftliche Zentrum Österreichs. Fuel72 liefert professionelle UGC Videos für den österreichischen Markt.", items: ["UGC Videos für den österreichischen Markt", "KI-generiert — keine Creator-Suche", "72 Stunden Lieferung", "Ab 49€ pro Video"] },
      { title: "UGC für Wiener Branchen", content: "Vom 1. Bezirk bis Favoriten.", grid: [{ icon: "🏛️", title: "Tourismus", description: "Hotels und Sehenswürdigkeiten." }, { icon: "☕", title: "Kaffeehäuser", description: "Wiens Café-Kultur." }, { icon: "💇", title: "Beauty", description: "Salons und Spas." }, { icon: "🛍️", title: "Retail", description: "Shops und Boutiquen." }] },
    ]}
    faqs={[{ question: "Gibt es eine UGC Agentur in Wien?", answer: "Ja! Fuel72 bedient Wiener Unternehmen mit 72-Stunden Lieferung." }]}
    relatedPages={[{ href: "/ugc-agentur", label: "UGC Agentur Deutschland" }, { href: "/ugc-agentur-zuerich", label: "Zürich" }, { href: "/ugc-kaufen", label: "UGC kaufen" }]}
  />
);

export default UGCAgenturWien;
